import Vue from "vue";
import Vuex from "vuex";

// Modules
import app from "./app";
import appConfig from "./app-config";
import verticalMenu from "./vertical-menu";
import council from "./council";
import pondok from "./pondok";
import area from "./area";
import agent from "./agent";
import offence from "./offence";
import holiday from "./holiday";
import company from "./company";
import user from "./user";
import rolePermission from "./role-permission";
import coupon from "./coupon";
import op from "./op";
import pa from "./pa";
import auditTrail from "./audit-trail";
import report from "./report";
import twoFactor from "./two-factor";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    council,
    pondok,
    area,
    agent,
    offence,
    holiday,
    company,
    user,
    rolePermission,
    coupon,
    op,
    pa,
    auditTrail,
    report,
    twoFactor,
  },
  strict: process.env.DEV,
});
